import ApiKeyService from "@/services/apiKey";

export default {
  namespaced: true,
  state: {
    apiKey: [],
  },

  getters: {
    async getApiKeys({ commit, state, getters, dispatch }) {
      try {
        const response = await ApiKeyService.getApiKeys();
        return response.data && response.data.attributes
          ? response.data.attributes
          : [];
      } catch (e) {
        console.log(e);
      }
    },
  },

  actions: {
    async storeApiKeys({ commit, state, getters, dispatch }) {
      try {
        const response = await ApiKeyService.storeApiKeys();
        return response.data && response.data.attributes ? response.data.attributes : {}
      } catch (e) {
        console.log(e);
      }
    },
    async deleteApiKeys({ commit, state, getters, dispatch }, id) {
			try {
				await ApiKeyService.deleteApiKeys(id);
			} catch (e) {
				console.log(e);
			}
		},
  },

  mutations: {},
};
